import React, { useState, useEffect, useContext } from "react";
import {
  MDBBtn,
  MDBCard,
  MDBCol,
  MDBContainer,
  MDBRow,
} from "mdb-react-ui-kit";
import axios from "axios";
// config
import configData from "../../../config/config.json";
// compponnents
import MetaTagsBusinessOwners from "../../../components/meta-tags-seo/MetaTagsBusinessOwners";
import Sidbarbusiness from "../../../components/business-dashboard/sidbar/Sidbarbusiness";
import HeaderMobile from "../../../components/business-dashboard/sidbar/HeaderMobile";
import InfoPage from "../../../components/business-dashboard/setting-pages/InfoPage";
import PassPage from "../../../components/business-dashboard/setting-pages/PassPage";

const BusinessSetting = (props) => {
  const [render, setRender] = useState(false);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = useState({});

  const [infoOrPass, setInfoOrPass] = useState(true);
  const pageHandler = (btn) => {
    if (btn === "info") {
      setInfoOrPass(true);
    } else if (btn === "pass") {
      setInfoOrPass(false);
    }
  };

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "business-setting",
    Authorization: "Bearer " + getCookie("token"),
  };
  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  //for+ loading state
  const [infoApiCome, setInfoApiCome] = useState(false);
  const [apiInfoData, setApiInfoData] = useState({});
  const [OldPassword, setOldPassword] = useState(true);

  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else if (render) {
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });

      setInfoApiCome(false);
      axios
        .get(configData.API_DOMAIN + "/api/v1/BusinessOwners", {
          headers: header,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setInfoApiCome(true);
            var data = response.data.data;
            setApiInfoData({
              firstname: data.firstname,
              lastname: data.lastname,
              email: data.email,
              username: data.username,
            });
            setOldPassword(data.setPassword);
          } else {
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, [render]);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  let windowWidth = "00";
  if (typeof window !== "undefined") {
    // Code that relies on the window object
    windowWidth = window.innerWidth;
  } else {
    windowWidth = "00";
  }

  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      {windowWidth < 768 ? <HeaderMobile setRender={setRender} /> : ""}
      <div className="margin-0 d-flex bg_business_grey">
        <div className="  d-none d-md-block">
          {windowWidth > 767 ? <Sidbarbusiness setRender={setRender} /> : ""}
        </div>
        <MDBContainer className="bg_business_grey">
          <MDBRow>
            <MDBCol size="12">
              <div className="container-dashboard-bus">
                <div className="d-block">
                  <p className="text_img_bus mx-0 mb-0">تنظیمات حساب</p>
                </div>
                <div className="dash-setting-btns">
                  <button
                    className={
                      infoOrPass
                        ? "dash-btn-active dash-setting-btn"
                        : "dash-setting-btn"
                    }
                    onClick={() => pageHandler("info")}
                    // rippleColor="success"
                  >
                    اطلاعات حساب
                  </button>
                  <button
                    className={
                      !infoOrPass
                        ? "dash-btn-active dash-setting-btn me-3"
                        : "dash-setting-btn me-3"
                    }
                    onClick={() => pageHandler("pass")}
                    // rippleColor="success"
                  >
                    رمز عبور
                  </button>
                </div>
                {infoOrPass ? (
                  <InfoPage
                    apiInfoData={apiInfoData}
                    infoApiCome={infoApiCome}
                  />
                ) : (
                  <PassPage
                    OldPassword={OldPassword}
                    infoApiCome={infoApiCome}
                  />
                )}
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
        {/* left */}
      </div>
    </>
  );
};

export default BusinessSetting;
